import { DocumentReference } from '.';

export class Document {

    id?: string;
    displayName: string;
    
    isActive: boolean;
    isDeleted: boolean;

    serviceYear: string;

    createdBy: DocumentReference;
    createdAt: Date;
    updatedBy: DocumentReference;
    updatedAt: Date;
}
